import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CasiEventName } from '../common/constants.lib';
import { CasiEvent } from '../common/obj.lib';

@Injectable({
  providedIn: 'root'
})
export class CasiEventService {

  private _casiEvent: BehaviorSubject<CasiEvent> = new BehaviorSubject<CasiEvent>(new CasiEvent(CasiEventName.notSet));
  get casiEvent$() {
    return this._casiEvent.asObservable();
  }
  get casiEvent() {
    return this._casiEvent.getValue();
  }
  set casiEvent(val: CasiEvent) {
    this._casiEvent.next(val);

  }
  constructor() { }
}
